import React, {useCallback, useEffect, useState} from 'react';
import {Box, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import {CLFBDetalle, schemaCLFBDetalle} from "../types/types";
import {zodResolver} from "@hookform/resolvers/zod/dist/zod";
import {OperacionCLFBDetalleFields} from "../types/fields";
import {TextField} from "src/lib/itaptec/components_forms/src";
import {HttpCacheOperacion} from "../../../api/httpCacheOperacion";
import {AsyncSelect} from "../../../../../components/forms";
import {EntityWithIdAndDescriptionFields} from "../../../../../types";


interface SeccionCLFBCampoHoldingPeriodProps {
  detalle: CLFBDetalle,
  codPais: number,
  permiteEditar: boolean,
  tipoHoldingPeriod: 'verde' | 'amarilla' | 'roja',
  handleConfirm: (data: CLFBDetalle) => void
}

const tiposHoldingPeriod: Record<string, keyof CLFBDetalle> = {
  'verde': OperacionCLFBDetalleFields.HoldingPeriodVerde,
  'amarilla': OperacionCLFBDetalleFields.HoldingPeriodAmarilla,
  'roja': OperacionCLFBDetalleFields.HoldingPeriodRoja
}

function CLFBDetalleCampoHoldingPeriod({
                                         detalle,
                                         codPais,
                                         permiteEditar,
                                         tipoHoldingPeriod,
                                         handleConfirm
                                       }: SeccionCLFBCampoHoldingPeriodProps) {

  const campoHoldingPeriod = tiposHoldingPeriod[tipoHoldingPeriod]
  const [editable, setEditable] = useState<boolean>(false);
  const [freeSolo, setFreeSolo] = useState<boolean>(false);

  const {control, handleSubmit} = useForm<CLFBDetalle>({
    resolver: zodResolver(schemaCLFBDetalle),
    defaultValues: {
      ...detalle
    }
  })

  const watchHoldingPeriod = useWatch({control: control, name: campoHoldingPeriod})

  const onUpdateDetalle: SubmitHandler<CLFBDetalle> = (data) => {
    handleConfirm(data)
  }

  const getOpciones = useCallback(() =>
      HttpCacheOperacion.getHoldingPeriods(codPais)
    , [])

  useEffect(() => {
    if (watchHoldingPeriod === null) {
      setFreeSolo(true)
    }
  }, [watchHoldingPeriod])


  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='nowrap'>
      {
        (permiteEditar && editable) ?
          !freeSolo ?
            <Stack direction={'row'}>
              <AsyncSelect
                control={control}
                name={campoHoldingPeriod}
                label={tipoHoldingPeriod}
                fullWidth
                optionSuffix={' días'}
                loadOptions={getOpciones}
                valueField={EntityWithIdAndDescriptionFields.Description}
                nullOptionLabel={'Otro'}
              />
            </Stack>

            :
            <TextField
              <CLFBDetalle>
              control={control}
              name={campoHoldingPeriod}
              label={tipoHoldingPeriod}
              fullWidth
              sx={{minWidth: '200px', width: '100%'}}
              autoFocus
            />
          :
          <Typography noWrap variant='body2'>
            {detalle[campoHoldingPeriod]}
          </Typography>
      }
      {
        permiteEditar &&
        (
          editable ?
            <Box display='flex' justifyContent='center' flexWrap='nowrap'>
              <Tooltip title='Cancelar'>
                <IconButton onClick={() => setEditable(false)}>
                  <CancelIcon color='error'/>
                </IconButton>
              </Tooltip>
              <Tooltip title='Confirmar'>
                <IconButton onClick={handleSubmit(onUpdateDetalle)}>
                  <CheckCircleIcon color='success'/>
                </IconButton>
              </Tooltip>
            </Box>
            :
            <Tooltip title='Editar'>
              <IconButton onClick={() => setEditable(true)}>
                <EditIcon color='info'/>
              </IconButton>
            </Tooltip>
        )
      }
    </Box>
  )
}

export default CLFBDetalleCampoHoldingPeriod;